import React from "react";
import LotterySlider from "./LotterySlider";
import { LotteryUpcomingData } from "../../helper/Helper";
import { LotteryIcon } from "../../helper/Icon2";

function LotteryTabContent() {
  return (
    <>
      <LotterySlider
        icon={<LotteryIcon />}
        sectionHeading={" Lottery Upcoming Draw"}
        data={LotteryUpcomingData}
      />
    </>
  );
}

export default LotteryTabContent;
